import apiCore from '../../utils/api-core';

export function getAllDepartments() {
	return apiCore.get('/api/v1/departments');
}

export function getAllDepartmentsByCompany() {
	return apiCore.get('/api/v1/departments/company');
}

export function getDepartmentById(id) {
	return apiCore.get(`/api/v1/departments/${id}`);
}

export function getDepartmentByCompany(id) {
	return apiCore.get(`/api/v1/departments/company/${id}`);
}

export function deleteDepartment(id) {
	return apiCore.delete(`/api/v1/departments/${id}`);
}

export function createDepartment(data) {
	return apiCore.post('/api/v1/departments', data);
}

export function updateDepart(id, data) {
	return apiCore.put(`/api/v1/departments/${id}`, data);
}
